export enum BackendNotificationTypes {
  ERegistrationCardChanged = 'ReservationsViews.ERegistrationCardChanged',
}
